<template>
    <div>
        <h1>Binds</h1>
        {{counter}}
        <a-button @click="incCounter" type="primary">+</a-button>
        <compOne :hui.sync="counter"/>
        
        <compTwo :value="counter" @input="(value)=>counter=value"/>
        <compThree v-model="counter"/>
        
        <h1>Events</h1>
        <button @click="addToFourComp">Add B</button>
        <compFour ref="four"/>
        <compFive @add-sym="addLetter"/>
        <button @click="addLetter('Z')">Add Z</button>

    </div>
</template>

<script>

import compOne from '../components/test/comp1';
import compTwo from '../components/test/comp2';
import compThree from '../components/test/comp3';
import compFour from '../components/test/comp4';
import compFive from '../components/test/comp5';




export default {

    components:{
        compOne,compTwo,compThree,
        compFour,compFive
    },

    data() {
        return {
            counter:0
        }
    },
    methods: {
        incCounter(){
            ++this.counter
        },
        addToFourComp(){
            this.$refs.four.addSymbol('b')
        },
        addLetter(data){
            this.$refs.four.addSymbol(data)
        }
    },

}
</script>

<style>

</style>